namespace GeniuzPOS.Lookups {
    export interface VwPosStationRow {
        Id?: number;
        PosId?: string;
        PosPermitNo?: string;
        ShopId?: string;
        WhsId?: string;
        LastReceiptRunNo?: number;
        LastRefundRunNo?: number;
        CashierPosFg?: number;
        PosScreenType?: string;
        PromptPayLink?: string;
        QrCodeAccount?: string;
        PosTouchPanelId?: string;
        MaxCashInDrawer?: number;
        AutoChargeFg?: number;
        AutoChargeRate?: number;
        MandatorySalesmanFg?: number;
        MandatoryMemberFg?: number;
        ConnectPrinterFg?: number;
        ConnectDrawerFg?: number;
        ConnectVfdFg?: number;
        Connect2ndDispFg?: number;
        ConnectEdcFg?: number;
        ConnectRfidReaderFg?: number;
        SellingPriceNo?: number;
        PsParaDefault1?: number;
        ShopLogoOnFrontScreen?: string;
        ShopLogoOnReceipt?: string;
        RecptHeadMesg1?: string;
        RecptHeadMesg2?: string;
        RecptHeadMesg3?: string;
        RecptHeadMesg4?: string;
        RecptHeadMesg5?: string;
        RecptHeadMesg6?: string;
        RecptFootMesg1?: string;
        RecptFootMesg2?: string;
        RecptFootMesg3?: string;
        RecptFootMesg4?: string;
        RecptFootMesg5?: string;
        RecptFootMesg6?: string;
        RecptFootMesg7?: string;
        RecptFootMesg8?: string;
        RecptFootMesg9?: string;
        RecptFootMesg10?: string;
        RecptNoBarcodeFg?: number;
        PsParaDefault2?: number;
        SelectSellingPriceFg?: number;
        ReceiptPrinterType?: number;
        SalesDocFg?: number;
        SalesVatType?: string;
        EjournalFg?: number;
        NoOfRecptCopy?: number;
        PrintOrderFg?: number;
        PrintQueueFg?: number;
        ItemOnRecptMethod?: number;
        RecptSumItemQtyFg?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ConnectEdcPort?: string;
        RecptHeadMesgFontSize?: number;
        RecptHeadMesgTextAlign?: number;
        RecptFootMesgFontSize?: number;
        RecptFootMesgTextAlign?: number;
        EdcBank?: string;
    }

    export namespace VwPosStationRow {
        export const idProperty = 'PosId';
        export const nameProperty = 'PosId';
        export const localTextPrefix = 'Lookups.VwPosStation';
        export const lookupKey = 'Lookups.VwPosStation';

        export function getLookup(): Q.Lookup<VwPosStationRow> {
            return Q.getLookup<VwPosStationRow>('Lookups.VwPosStation');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PosId = "PosId",
            PosPermitNo = "PosPermitNo",
            ShopId = "ShopId",
            WhsId = "WhsId",
            LastReceiptRunNo = "LastReceiptRunNo",
            LastRefundRunNo = "LastRefundRunNo",
            CashierPosFg = "CashierPosFg",
            PosScreenType = "PosScreenType",
            PromptPayLink = "PromptPayLink",
            QrCodeAccount = "QrCodeAccount",
            PosTouchPanelId = "PosTouchPanelId",
            MaxCashInDrawer = "MaxCashInDrawer",
            AutoChargeFg = "AutoChargeFg",
            AutoChargeRate = "AutoChargeRate",
            MandatorySalesmanFg = "MandatorySalesmanFg",
            MandatoryMemberFg = "MandatoryMemberFg",
            ConnectPrinterFg = "ConnectPrinterFg",
            ConnectDrawerFg = "ConnectDrawerFg",
            ConnectVfdFg = "ConnectVfdFg",
            Connect2ndDispFg = "Connect2ndDispFg",
            ConnectEdcFg = "ConnectEdcFg",
            ConnectRfidReaderFg = "ConnectRfidReaderFg",
            SellingPriceNo = "SellingPriceNo",
            PsParaDefault1 = "PsParaDefault1",
            ShopLogoOnFrontScreen = "ShopLogoOnFrontScreen",
            ShopLogoOnReceipt = "ShopLogoOnReceipt",
            RecptHeadMesg1 = "RecptHeadMesg1",
            RecptHeadMesg2 = "RecptHeadMesg2",
            RecptHeadMesg3 = "RecptHeadMesg3",
            RecptHeadMesg4 = "RecptHeadMesg4",
            RecptHeadMesg5 = "RecptHeadMesg5",
            RecptHeadMesg6 = "RecptHeadMesg6",
            RecptFootMesg1 = "RecptFootMesg1",
            RecptFootMesg2 = "RecptFootMesg2",
            RecptFootMesg3 = "RecptFootMesg3",
            RecptFootMesg4 = "RecptFootMesg4",
            RecptFootMesg5 = "RecptFootMesg5",
            RecptFootMesg6 = "RecptFootMesg6",
            RecptFootMesg7 = "RecptFootMesg7",
            RecptFootMesg8 = "RecptFootMesg8",
            RecptFootMesg9 = "RecptFootMesg9",
            RecptFootMesg10 = "RecptFootMesg10",
            RecptNoBarcodeFg = "RecptNoBarcodeFg",
            PsParaDefault2 = "PsParaDefault2",
            SelectSellingPriceFg = "SelectSellingPriceFg",
            ReceiptPrinterType = "ReceiptPrinterType",
            SalesDocFg = "SalesDocFg",
            SalesVatType = "SalesVatType",
            EjournalFg = "EjournalFg",
            NoOfRecptCopy = "NoOfRecptCopy",
            PrintOrderFg = "PrintOrderFg",
            PrintQueueFg = "PrintQueueFg",
            ItemOnRecptMethod = "ItemOnRecptMethod",
            RecptSumItemQtyFg = "RecptSumItemQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ConnectEdcPort = "ConnectEdcPort",
            RecptHeadMesgFontSize = "RecptHeadMesgFontSize",
            RecptHeadMesgTextAlign = "RecptHeadMesgTextAlign",
            RecptFootMesgFontSize = "RecptFootMesgFontSize",
            RecptFootMesgTextAlign = "RecptFootMesgTextAlign",
            EdcBank = "EdcBank"
        }
    }
}
